import React from "react";
import ServiceBox from "../../../../components/Shared/ServiceBox";
import { Container, Row, Col } from "reactstrap";
import {Link} from "gatsby";
import {services} from "../../../../constants/company";

export default function Services() {
  return (<section className="section py-5 service-carousel-section">
    <div className="text-center mb-5">
      <div className="small-title text-primary">Our services</div>
      <h4 className="text-secondary">How Mavsign can help</h4>
    </div>
    <Container>
      <Row>
        {services.map((service, index) =>
          <Col className="service-custom-col" xl={3} md={5} sm={12} key={index}>
            <ServiceBox description={service.description} title={service.title} icon={service.icon} />
            <Link to={`/services/${'#' + service.readMore}`}>read more</Link>
          </Col>
        )}
        </Row>
    </Container>
  </section>
)}
